class AlumneCasal {
    constructor(
        public key: number = 0,
        public id: number = 0,
        public id_activitat: number = 0,
        public id_alumne_casal: number = 0,
        public value: number = 0,
        public nom: string = "",
        public label: string = "",
        public cognoms: string = "",
        public data_naix: string = "",
        public modificacio: string = "",
        public curs: string = "",
        public cicle: string = "",
        public observacions: string = "",
        public id_escola: number = 0,
        public id_campus: number = 0,
        public id_casal: number = 0,
        public id_escola_entrada: number = 0,
        public estat: number = 0,
        public activitat: string = "",
        public estat_activitat: string = "",
    ) {}
}

export default AlumneCasal;
